import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import buildInvoiceRoute, { INVOICES_PATH } from "~/helpers/invoiceRoute";

export const INVOICE_TARGET_KIND = "invoice";
export const INVOICES_DOCK_PAGE_ID = "sales-invoices";

const invoiceReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildInvoiceRoute(targetId),
	matchesRoute: (pathname) => {
		const match = new RegExp(`^${INVOICES_PATH}/([^/?#]+)$`).exec(pathname);
		if (!match) return null;
		try {
			return { targetId: decodeURIComponent(match[1]), targetKind: INVOICE_TARGET_KIND };
		} catch {
			return null;
		}
	}
};

export default invoiceReceiverIdentityAdapter;
